import MetaMask from '../../src/legacy/MetaMask';
export default MetaMask;
